import React from 'react';
import { Card, Typography, Row, Col, Space, Button } from 'antd';

const { Title, Paragraph, Text } = Typography;

export const Tutorials = ({ setLoading, showMessage }) => {
    const tutorials = [
        { title: 'آموزش رزرو اتاق', duration: '10 دقیقه', level: 'مقدماتی' },
        { title: 'گزارش‌گیری پیشرفته', duration: '۱۵ دقیقه', level: 'پیشرفته' },
        { title: 'تنظیمات سیستم', duration: '۸ دقیقه', level: 'متوسط' },
        { title: 'مدیریت کاربران', duration: '۱۲ دقیقه', level: 'پیشرفته' },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Card>
                <Title level={2}>آموزش‌های کاربردی</Title>
                <Paragraph type="secondary">
                    ویدیوها و راهنماهای آموزشی برای استفاده بهتر از سیستم
                </Paragraph>
                
                <Row gutter={[16, 16]}>
                    {tutorials.map((tutorial, index) => (
                        <Col xs={24} md={12} key={index}>
                            <Card hoverable>
                                <Row align="middle">
                                    <Col flex="auto">
                                        <Title level={5}>{tutorial.title}</Title>
                                        <Space>
                                            <Text type="secondary">مدت زمان: {tutorial.duration}</Text>
                                            <Text type="secondary">سطح: {tutorial.level}</Text>
                                        </Space>
                                    </Col>
                                    <Col>
                                        <Button type="primary">مشاهده آموزش</Button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>
        </div>
    );
};